import { Module } from 'vuex';
import { getToken } from '@/features/auth/helpers';
import { Auth } from '../types';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const auth: Module<Auth, any> = {
  state: {
    isAuth: !!getToken(),
    user: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      country: '',
      address: '',
      postalCode: 0,
      whosShipping: '',
      companyName: '',
      website: [''],
      industry: '',
      teamSize: '',
      whereShip: '',
    },
  },
  mutations,
  getters,
  actions,
};

export default auth;
